// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__39nM6","notes":"Notes_notes__qD5NC"};